import { connect } from "react-redux";
import goalsList from "../../../components/goalsList/goalsList";
import { actionCreators } from "../redux/sagas/goals/goals";

export default connect(
  state => ({
    isAnimated: false,
    listHeight: 55,
    expandedHeight: 115,
    customClass: "membershipGoals",
    title: state.goals.goals.membershipsTitle || "Membership",
    goalData: state.goals.goals.memberships && state.goals.goals.memberships.length > 0 ? state.goals.goals.memberships : null,
    currentUser: state.goals.currentUser
  }),
  {
    saveGoal: (id, value, active) => {
      let data = {
        id: id,
        value: value,
        active: active
      };
      return actionCreators.updateGoal(data);
    },
    saveGoalAsValue: (id, value, active) => {
      let data = {
        id: id,
        value: value,
        active: active
      };
      return actionCreators.updateGoalAsValue(data);
    }
  }
)(goalsList);
